<div class="flex" style="margin-top: 15px;">
  <div class="card" *ngIf="device.technicalDetails">
    <ngx-json-viewer [json]="jsonData"></ngx-json-viewer>
  </div>
  <div class="card w-full" *ngIf="!device.technicalDetails && !loadingTechnicalDetails">
    <p class="text-xl text-center p-6 font-italic">{{'empty.technicalDetails' | transloco}}</p>
  </div>
  <div class="card w-full" *ngIf="!device.technicalDetails && loadingTechnicalDetails">
    <app-table-skeleton [rows]="3"></app-table-skeleton>
  </div>
</div>
